// extracted by mini-css-extract-plugin
export var card = "_8c-1";
export var container = "_8c-0";